import React, {Component} from 'react';

import PortalAdminCompany from './PortalAdminCompany';

import sAction from 'sAction';

class PortalAdminAccessTree extends React.Component {
    render() {
        const branches = this.props.branches;

        return <div className="portalAdminColumn branchColumn">
            <div className="search adminTreeSearch">
                <input
                    type="text"
                    className="search"
                    placeholder={sAction.translate('LBL_SEARCH')+'...'}
                    onChange={(ev) => this.props.search(ev.target.value)}
                />
            </div>
            {
                Object.keys(branches).map((key, index) =>
                    <PortalAdminCompany
                        key={branches[key].id}
                        data={branches[key]}
                        deleteUser={this.props.deleteUser}
                        deleteRole={this.props.deleteRole}
                        bId={key}
                    />,
                )
            }
        </div>;
    }
}
export default PortalAdminAccessTree;
